import { sports } from './sports';
import { IAttribute, ISports } from '../interfaces';
import { useLocation } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sportDetail = (): ISports => {
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    return sports().find((s) => s.key === sport);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const attributes = (): IAttribute[] | [] => {
    const sport = sportDetail();
    if (sport) {
        const listAttributes = [
            {
                type: 'rent',
                url: '/arrienda',
                title: 'ARRENDAR',
                subTitle: 'Canchas Disponibles para arriendo',
                content: 'Reserva tu cancha',
                icon: {
                    image: sport.icons.arrienda,
                    height: 70,
                    width: 107,
                    class: 'pl-10',
                },
                image: sport.backgrounds.arrienda,
                alt: 'Seleccionar Arrienda',
                color: {
                    bg: 'bg-sm-rent-light',
                    bgButton: 'bg-sm-rent',
                    hover: {
                        text: 'hover:text-green-700',
                        bg: 'hover:bg-green-300',
                    },
                },
                bt: {
                    name: 'Arrendar',
                    card: 'Seleccionar',
                },
                separator: 1,
                responsive: { 0: { items: 1 }, 1024: { items: 8 } },
                filter: {
                    title: 'Arrendar Cancha',
                    btName: 'Siguiente',
                    btColor: 'bg-sm-integrate',
                },
                sport: null,
            },
            {
                type: 'integrate',
                title: 'INTEGRAR',
                subTitle: 'Partidos para integrar',
                content: 'Únete a un partido',
                icon: {
                    image: sport.icons.integra,
                    height: 70,
                    width: 85,
                    class: 'pl-14',
                },
                url: '/integrar',
                image: sport.backgrounds.integra,
                alt: 'Seleccionar Integrar',
                color: {
                    bg: 'bg-gray-100',
                    bgButton: 'bg-sm-integrate',
                    hover: {
                        text: 'hover:text-pink-700',
                        bg: 'hover:bg-pink-300',
                    },
                },
                bt: {
                    name: 'Integrar',
                    card: 'Ver Detalle',
                },
                separator: 1,
                responsive: { 0: { items: 1 }, 1024: { items: 8 } },
                filter: {
                    title: 'Unete a nuestros partidos',
                    btName: 'Siguiente',
                    btColor: 'bg-sm-integrate',
                },
                sport: null,
            },
            {
                type: 'defy',
                title: 'DESAFIAR',
                subTitle: 'Cancha + Rival',
                content: 'Cancha + Rival',
                icon: {
                    image: sport.icons.desafia,
                    height: 70,
                    width: 89,
                    class: 'pl-14',
                },
                url: '/desafiar',
                new: false,
                image: sport.backgrounds.desafia,
                alt: 'Seleccionar Desafíar',
                color: {
                    bg: 'bg-sm-defy-light',
                    bgButton: 'bg-sm-defy',
                    hover: {
                        text: ' hover:text-gray-700',
                        bg: 'hover:bg-gray-300',
                    },
                },
                bt: {
                    name: 'Desafíar',
                    card: 'Desafíar',
                },
                separator: 1,
                responsive: { 0: { items: 1 }, 1024: { items: 8 } },
                filter: {
                    title: 'Cancha + Rival',
                    btName: 'Siguiente',
                    btColor: 'bg-sm-integrate',
                },
                sport: null,
            },
            {
                type: 'tourney',
                title: 'TORNEOS',
                subTitle: 'Pronto',
                content: 'Compite en un SuperTorneo',
                icon: {
                    image: sport.icons.torneo,
                    height: 70,
                    width: 70,
                    class: 'pl-14',
                },
                url: '#',
                image: sport.backgrounds.torneo,
                alt: 'Seleccionar Torneo',
                color: {
                    bg: 'bg-sm-tourney-light',
                    bgButton: 'bg-sm-tourney',
                    hover: {
                        text: ' hover:text-yellow-700',
                        bg: 'hover:bg-yellow-300',
                    },
                },
                bt: {
                    name: 'Participar',
                    card: 'Participar',
                },
                separator: 1,
                responsive: { 0: { items: 1 }, 1024: { items: 8 } },
                filter: {
                    title: 'Torneo',
                    btName: 'Siguiente',
                    btColor: 'bg-sm-integrate',
                },
                sport: null,
            },
        ];
        return listAttributes;
    } else return [];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const attributesBySport = (type: string): IAttribute => {
    const listAttributes = attributes();
    const data =
        listAttributes &&
        listAttributes.length > 0 &&
        listAttributes.map((a) => {
            const detail = sportDetail();
            return { ...a, sport: detail };
        });
    return data.find((a) => a.type === type);
};
